<template>
<div>
            <v-card>
                <v-row>
                    <v-col cols="2" class="pt-6" align="center">
                        {{ $t('group_close_general') }} : 
                    </v-col>
                    <v-col cols="9" align="left">
                        <v-row>
                            <v-chip
                                v-for="item in tag_close_general_items"
                                :key="item"
                                class="ma-2"
                                close
                                close-icon="mdi-delete"
                                @click:close="delGeneralCloseTag(item)"
                            >
                                {{ $t('tag_close_' + item) }}
                            </v-chip>
                        </v-row>
                    </v-col>
                    <v-col cols="1">
                        <v-menu offset-y>
                            <template v-slot:activator="{ on, attrs }">
                                <v-btn 
                                    tile 
                                    icon
                                    v-bind="attrs"
                                    v-on="on"
                                >
                                    <v-icon>mdi-plus</v-icon>
                                </v-btn>
                            </template>
                            <v-list>
                                <v-list-item
                                    v-for="(item, index) in datemask_items"
                                    :key="index"
                                    @click="addGeneralCloseTag(item.mask_tag)"
                                >
                                <v-list-item-title>{{ $t('tag_close_' + item.mask_tag) }}</v-list-item-title>
                                </v-list-item>
                            </v-list>
                        </v-menu>
                    </v-col>
                </v-row>
                <v-row>
                    <v-col cols="2" class="pt-6" align="center">
                        {{ $t('group_close_extra') }} : 
                    </v-col>
                    <v-col cols="9" align="left">
                        <v-row>
                            <v-chip
                                v-for="item in extradate_close"
                                :key="item"
                                class="ma-2"
                                close
                                close-icon="mdi-delete"
                                @click:close="delExtradateClose(item)"
                            >
                                {{ $t(item) }}
                            </v-chip>
                        </v-row>
                    </v-col>
                    <v-col cols="1">
                        <v-dialog v-model="select_extradate_close" max-width="1024">
                            <v-card-text  class="mt-6" align="center">
                            <v-label>เลือกวันหยุด</v-label>
                                <div align="center" class="mt-4">
                                    <Calendar
                                        :columns="$screens({ default: 1, lg: 3 })"
                                        @dayclick="addExtradateClose"
                                        :locale="{id:$i18n.locale }"
                                    >
                                    </Calendar>
                                </div>
                            </v-card-text>
                        </v-dialog>
                        <v-btn tile icon @click="select_extradate_close=true">
                            <v-icon>mdi-plus</v-icon>
                        </v-btn>
                    </v-col>
                </v-row>
            </v-card>

            <div align="left" class="mt-4 mb-1 text"><b>
                {{ $t('group_timeslot_reservation') }}</b>
            </div>
            <v-card class="mt-1 mb-4">
                <v-simple-table fixed-header align="left" >
                    <thead>
                        <tr>
                        <th class="text-left">{{ $t('group_time') }}</th>
                        <th class="text-left">{{ $t('group_slot') }}</th>
                        <th class="text-left">
                            <v-btn tile icon @click="addTimeseat" :disabled="isNewTimeseat" >
                                <v-icon>mdi-plus</v-icon>
                            </v-btn>
                        </th>
                        </tr>
                    </thead>
                    <tbody >

                        <tr v-for="(item,i) in timeseat_items" :key="i"> 

                                                        <td v-if="item.isNew">
                                <v-select
                                    v-model="datemasklist_select_all"
                                    :items="datemasklist_item"
                                    @change="(val) => newtimeseat_open_date_mask = val"
                                    multiple
                                    outlined
                                    dense
                                ></v-select>
                            </td>
                            <td v-else>
                                {{item.open_date_mask_text}}
                            </td>


                            <td class="pt-4" v-if="item.isNew">
                                <FragmentSelectTimeRange
                                    @ontimestart="(val)=> newtimeseat_timestart = val"
                                    @ontimeend="(val)=> newtimeseat_timeend = val"
                                    :have_range_0="false"
                                ></FragmentSelectTimeRange>
                            </td>
                            <td v-else>
                                {{item.timeseat_str}}
                            </td>

                            <td v-if="item.isNew">
                                <v-text-field
                                    @change="(val) => newtimeseat_slot = val"
                                    :label="$t('group_slot')"
                                    outlined
                                    dense
                                ></v-text-field>
                            </td>
                            <td v-else>
                                {{item.seat}}
                            </td>

                            <td v-if="item.isNew">
                                <v-btn tile icon @click="submitTimeseat" :disabled="!isReadyTimeseat">
                                    <v-icon>mdi-check</v-icon>
                                </v-btn>
                            </td>
                            <td v-else>
                                <v-btn tile icon @click="delTimeseat(i)" :disabled="isNewTimeseat">
                                    <v-icon>mdi-trash-can</v-icon>
                                </v-btn>
                            </td>

                        </tr>

                    </tbody>
                </v-simple-table>
            </v-card>

            <div align="left" class="mt-4 mb-1 text"><b>
                {{ $t('group_timeslot_appointment') }}</b>
            </div>
            <v-card class="mt-1">
                <v-simple-table fixed-header align="left" >
                    <thead>
                        <tr>
                        <th class="text-left">วัน</th>
                        <th class="text-left">{{ $t('group_time') }}</th>
                        <th class="text-left">{{ $t('group_slot') }}</th>
                        <th class="text-left">
                            <v-btn tile icon @click="addTimeseat_appointment" :disabled="isNewTimeseat_appointment" >
                                <v-icon>mdi-plus</v-icon>
                            </v-btn>
                        </th>
                        </tr>
                    </thead>
                    <tbody >

                        <tr v-for="(item,i) in timeseat_items_appointment" :key="i"> 

                            <td v-if="item.isNew">
                                <v-select
                                    v-model="datemasklist_select_all"
                                    :items="datemasklist_item"
                                    @change="(val) => newtimeseat_open_date_mask = val"
                                    multiple
                                    outlined
                                    dense
                                ></v-select>
                            </td>
                            <td v-else>
                                {{item.open_date_mask_text}}
                            </td>

                            <td class="pt-4" v-if="item.isNew">
                                <FragmentSelectTimeRange
                                    @ontimestart="(val)=> newtimeseat_timestart_appointment = val"
                                    @ontimeend="(val)=> newtimeseat_timeend_appointment = val"
                                    :have_range_0="false"
                                ></FragmentSelectTimeRange>
                            </td>
                            <td v-else>
                                {{item.timeseat_str}}
                            </td>

                            <td v-if="item.isNew">
                                <v-text-field
                                    @change="(val) => newtimeseat_slot_appointment = val"
                                    :label="$t('group_slot')"
                                    outlined
                                    dense
                                ></v-text-field>
                            </td>
                            <td v-else>
                                {{item.seat}}
                            </td>

                            <td v-if="item.isNew">
                                <v-btn tile icon @click="submitTimeseat_appointment" :disabled="!isReadyTimeseat_appointment">
                                    <v-icon>mdi-check</v-icon>
                                </v-btn>
                            </td>
                            <td v-else>
                                <v-btn tile icon @click="delTimeseat_appointment(i)" :disabled="isNewTimeseat_appointment">
                                    <v-icon>mdi-trash-can</v-icon>
                                </v-btn>
                            </td>

                        </tr>

                    </tbody>
                </v-simple-table>
            </v-card>
</div>
</template>
<script>

  import axios from 'axios';
  import config from '@/../config.js'
  import Staff from '@/model/instance/Staff.js'
  import FragmentSelectTimeRange from '@/components/Common/FragmentSelectTimeRange.vue'
  import Calendar from 'v-calendar/lib/components/calendar.umd'

  export default {
    components: {
        FragmentSelectTimeRange
        ,Calendar
    },
    props: ["station_code","group_id"],
    data () {
        return {
            timeseat_items : []
            ,isNewTimeseat : false
            ,newtimeseat_timestart : null
            ,newtimeseat_timeend : null
            ,newtimeseat_slot : null
            ,newtimeseat_open_date_mask : null

            ,datemasklist : []
            ,datemasklist_item : []
            ,datemasklist_select_all : []

            ,tag_close_general_items : []
            ,extradate_close : []
            ,select_extradate_close : false

            ,timeseat_items_appointment : []
            ,isNewTimeseat_appointment : false
            ,newtimeseat_timestart_appointment : null
            ,newtimeseat_timeend_appointment : null
            ,newtimeseat_slot_appointment : null
        }
    },
    computed: {
        isReadyTimeseat(){
            return this.newtimeseat_timestart != null
                && this.newtimeseat_timeend != null
                && this.newtimeseat_slot != null
                && this.newtimeseat_slot.length > 0
        },
        isReadyTimeseat_appointment(){
            return this.newtimeseat_timestart_appointment != null
                && this.newtimeseat_timeend_appointment != null
                && this.newtimeseat_slot_appointment != null
                && this.newtimeseat_slot_appointment.length > 0
        },
        datemask_items(){
            return this.datemasklist.filter(m=>!this.tag_close_general_items.includes(m.mask_tag))
        }
    },
    methods : {
        reload : function() {
            var que = this.$store.commit('addLoading')
            axios.post(config.api.url.manage.appointment.group.get_groupdatedetail,{station_code:this.station_code,group_id:this.group_id},{ headers: Staff.getTokenHeader()})
            .then(response => {

                this.timeseat_items = response.data.timeseatlist
                this.timeseat_items.forEach((timeseat,i,arr)=>{
                    var ts = '000' + timeseat.timestart;
                    var te = '000' + timeseat.timeend;
                    arr[i]['timeseat_str'] = ts.substring(ts.length-4,ts.length-2) + ":" + ts.substring(ts.length-2,ts.length) + " - " + te.substring(te.length-4,te.length-2) + ":" + te.substring(te.length-2,te.length)
                    if(timeseat.open_date_mask==null){
                        arr[i]['open_date_mask_text'] = 'ทุกวัน'
                    }else{
                        arr[i]['open_date_mask_text'] = []
                        this.datemasklist_item.forEach(d=>{
                            if(d.value & timeseat.open_date_mask){
                                arr[i]['open_date_mask_text'].push(d.text)
                            }
                        })
                        arr[i]['open_date_mask_text'] = arr[i]['open_date_mask_text'].join(',')
                    }
                })
                

                this.timeseat_items_appointment = response.data.timeseatlist_appointment
                this.timeseat_items_appointment.forEach((timeseat,i,arr)=>{
                    var ts = '000' + timeseat.timestart;
                    var te = '000' + timeseat.timeend;
                    arr[i]['timeseat_str'] = ts.substring(ts.length-4,ts.length-2) + ":" + ts.substring(ts.length-2,ts.length) + " - " + te.substring(te.length-4,te.length-2) + ":" + te.substring(te.length-2,te.length)
                    if(timeseat.open_date_mask==null){
                        arr[i]['open_date_mask_text'] = 'ทุกวัน'
                    }else{
                        arr[i]['open_date_mask_text'] = []
                        this.datemasklist_item.forEach(d=>{
                            if(d.value & timeseat.open_date_mask){
                                arr[i]['open_date_mask_text'].push(d.text)
                            }
                        })
                        arr[i]['open_date_mask_text'] = arr[i]['open_date_mask_text'].join(',')
                    }
                    
                })
                console.log(response.data.timeseatlist_appointment)


                this.tag_close_general_items = response.data.tag_close_general
                this.extradate_close = response.data.extradate.filter(d=>d.extra_type==0).map(d=>{
                    var date = new Date(d.extra_date)
                    date.setHours(date.getHours()+7) 
                    return date.toISOString().substring(0,10)
                })

                this.$store.commit('finishLoading',que)
            }).catch(error => {
                this.$router.push({name:'Error',params:error}) 
            })
        },

        addTimeseat(){
            this.isNewTimeseat = true
            this.timeseat_items.push({isNew:true})
        },
        submitTimeseat(){
            if(this.newtimeseat_open_date_mask==null || this.newtimeseat_open_date_mask.length==this.datemasklist_item.length){
                this.newtimeseat_open_date_mask = null
            }
            var que = this.$store.commit('addLoading')
            axios.post(config.api.url.manage.appointment.group.add_groupslot,
            {
                station_code:this.station_code
                ,group_id:this.group_id
                ,timestart:this.newtimeseat_timestart
                ,timeend:this.newtimeseat_timeend
                ,seat:parseInt(this.newtimeseat_slot)
                ,open_date_mask:this.newtimeseat_open_date_mask == null ? null : this.newtimeseat_open_date_mask.reduce((a, b) => a + b, 0)
            },{ headers: Staff.getTokenHeader()})
            .then(() => {
                this.$store.commit('finishLoading',que)
                this.isNewTimeseat = false
                this.reload()
            }).catch(error => {
                this.$router.push({name:'Error',params:error}) 
            })

        },
        delTimeseat(i){
            var que = this.$store.commit('addLoading')
            axios.post(config.api.url.manage.appointment.group.del_groupslot,
            {
                station_code:this.station_code
                ,group_id:this.group_id
                ,timestart:this.timeseat_items[i].timestart
                ,timeend:this.timeseat_items[i].timeend
            },{ headers: Staff.getTokenHeader()})
            .then(() => {
                this.$store.commit('finishLoading',que)
                this.isNewTimeseat = false
                this.reload()
            }).catch(error => {
                this.$router.push({name:'Error',params:error}) 
            })
        },
        addGeneralCloseTag(tag){
            var que = this.$store.commit('addLoading')
            axios.post(config.api.url.manage.appointment.group.add_generalclosetag,
            {
                station_code:this.station_code
                ,group_id:this.group_id
                ,mask_tag:tag
            },{ headers: Staff.getTokenHeader()})
            .then(() => {
                this.$store.commit('finishLoading',que)
                this.reload()
            }).catch(error => {
                this.$router.push({name:'Error',params:error}) 
            })
        },
        delGeneralCloseTag(tag){
            var que = this.$store.commit('addLoading')
            axios.post(config.api.url.manage.appointment.group.del_generalclosetag,
            {
                station_code:this.station_code
                ,group_id:this.group_id
                ,mask_tag:tag
            },{ headers: Staff.getTokenHeader()})
            .then(() => {
                this.$store.commit('finishLoading',que)
                this.reload()
            }).catch(error => {
                this.$router.push({name:'Error',params:error}) 
            })
        },
        addExtradateClose(date){
            var que = this.$store.commit('addLoading')
            axios.post(config.api.url.manage.appointment.group.edit_extradate,
            {
                station_code:this.station_code
                ,group_id:this.group_id
                ,extra_date:date.id
                ,extra_type:0
            },{ headers: Staff.getTokenHeader()})
            .then(() => {
                this.$store.commit('finishLoading',que)
                this.select_extradate_close = false
                this.reload()
            }).catch(error => {
                this.$router.push({name:'Error',params:error}) 
            })
        },
        delExtradateClose(date){
            var que = this.$store.commit('addLoading')
            axios.post(config.api.url.manage.appointment.group.edit_extradate,
            {
                station_code:this.station_code
                ,group_id:this.group_id
                ,extra_date:date
                ,extra_type:null
            },{ headers: Staff.getTokenHeader()})
            .then(() => {
                this.$store.commit('finishLoading',que)
                this.reload()
            }).catch(error => {
                this.$router.push({name:'Error',params:error}) 
            })
        }

        ,addTimeseat_appointment(){
            this.isNewTimeseat_appointment = true
            this.timeseat_items_appointment.push({isNew:true})
        },
        submitTimeseat_appointment(){
            if(this.newtimeseat_open_date_mask==null || this.newtimeseat_open_date_mask.length==this.datemasklist_item.length){
                this.newtimeseat_open_date_mask = null
            }
            var que = this.$store.commit('addLoading')
            axios.post(config.api.url.manage.appointment.group.add_groupslotappointment,
            {
                station_code:this.station_code
                ,group_id:this.group_id
                ,timestart:this.newtimeseat_timestart_appointment 
                ,timeend:this.newtimeseat_timeend_appointment 
                ,seat:parseInt(this.newtimeseat_slot_appointment )
                ,open_date_mask:this.newtimeseat_open_date_mask == null ? null : this.newtimeseat_open_date_mask.reduce((a, b) => a + b, 0)
            },{ headers: Staff.getTokenHeader()})
            .then(() => {
                this.$store.commit('finishLoading',que)
                this.isNewTimeseat_appointment = false
                this.reload()
            }).catch(error => {
                this.$router.push({name:'Error',params:error}) 
            })

        },
        delTimeseat_appointment(i){
            var que = this.$store.commit('addLoading')
            axios.post(config.api.url.manage.appointment.group.del_groupslotappointment,
            {
                station_code:this.station_code
                ,group_id:this.group_id
                ,timestart:this.timeseat_items_appointment[i].timestart
                ,timeend:this.timeseat_items_appointment[i].timeend
            },{ headers: Staff.getTokenHeader()})
            .then(() => {
                this.$store.commit('finishLoading',que)
                this.isNewTimeseat_appointment = false
                this.reload()
            }).catch(error => {
                this.$router.push({name:'Error',params:error}) 
            })
        },
        change_newtimeseat_open_date_mask_appointment(val){
            console.log(val)
        }
    },
    mounted : function () {
        this.reload()
        var que = this.$store.commit('addLoading')
        axios.post(config.api.url.public.get_datemasklist).then(response => {
            this.datemasklist = response.data.datemasklist
            this.datemasklist.forEach(d=>{
                this.datemasklist_item.push({
                    text:this.$i18n.t('mask_tag_'+d.mask_tag)
                    ,value:d.mask
                })
                this.datemasklist_select_all.push(d.mask)
            })
            
            this.$store.commit('finishLoading',que)
        }).catch(error => {
            this.$router.push({name:'Error',params:error}) 
        })
    } 
  }
</script>